export default {
  name: 'evernorth',
  trackingId: 'enterHere'
}
